module.exports = __webpack_public_path__ + "static/evolution.cbc03b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/evolution.png
// module id = 793
// module chunks = 34885888655430